window.Calculator = function () {
    var el = this;
    var minPrice = window.minPrice;
    el.properties = window.calculatorProperties;
    var groups = window.calculatorGroups;
    var price = window.calculatorPrice;
    el.propLinks = window.calculatorPropertiesLinks;
    var currency = window.currency;
    var FLYLEAF_GROUP = 7;
    var COVER_GROUP = 2;

    var template = $('#parameters-template').html();

    el.coverGroup;
    el.data = {};

    el.show = function () {
        var left = screen.availWidth / 2 - 475;
        var height = screen.availHeight - 75;
        var url = window.location.protocol + '//' + window.location.hostname + '/products/photobooks/calculator/popup';
        var params = "width=990,height=" + height + ",resizable=no,scrollbars=yes,toolbar=no,location=no,status=no,menubar=no,directories=no,left=" + left;
        window.open(url, Yii.t('Photobook Options'), params);
    };

    el.init = function (cb) {
        // определяем указаны ли цены обложек за выбранный тип фотокниги
        if (!minPrice.covers.hasOwnProperty(el.currentType.id)) {
            el.dialog.show('message', { message: Yii.t('There are no covers for this type of photobook') });
            return false;
        }

        var cover = minPrice.covers[el.currentType.id];

        // инициализация данных калькулятора
        el.data = {
            book_types: el.currentType.id,
            formats: el.currentFormat.id,
            cost: 0,
            count: 1,
            cover: cover.id,
            decors: {},
            design: 0,
            paper: minPrice.papers[el.currentType.id].id
        };

        // достаем тип обложки (фотообложка или нет)
        el.coverGroup = el.properties.cover[el.data.cover].group_id;

        // устанавливаем материал обложки если не указан дефолтный,
        // то устанавливаем первый попавшиеся

        if (
            el.propLinks.hasOwnProperty(COVER_GROUP)
            && el.propLinks[COVER_GROUP].hasOwnProperty(el.data.cover)
            && Object.keys(el.propLinks[COVER_GROUP][el.data.cover]).length > 0
        ) {

            el.data.cover_material = cover.material_id !== null ? cover.material_id : el.propLinks[COVER_GROUP][el.data.cover][0];

            // если обложка является не фотообложкой, то очищаем фон обложки в редакторе
            if (
                parseInt(el.coverGroup) === el.NOTPHOTOCOVER
                && parseInt(el.properties.cover_material[el.data.cover_material].constructor_image) === 1
                && el._parent.workData.hardcover
            ) {
                el._parent.workData.hardcover[1].backgrounds = {};
            }
        }

        //устанавливаем форзац с минимальной стоимостью
        if (
            minPrice.flyleafs.hasOwnProperty(el.currentType.id)
            && minPrice.flyleafs[el.currentType.id].prices.hasOwnProperty(el.currentFormat.id)
        ) {
            var flyleaf = minPrice.flyleafs[el.currentType.id];
            el.data.flyleaf = flyleaf.id;

            // устанавливаем материал форзаца
            if (
                el.propLinks.hasOwnProperty(FLYLEAF_GROUP)
                && el.propLinks[FLYLEAF_GROUP].hasOwnProperty(el.data.flyleaf)
                && Object.keys(el.propLinks[FLYLEAF_GROUP][el.data.flyleaf]).length > 0
            ) {

                el.data.flyleaf_material = flyleaf.material_id !== null ? flyleaf.material_id : el.propLinks[FLYLEAF_GROUP][el.data.flyleaf][0];
            }
        }

        // переустановка свойств если указаны эти свойства в проекте фотокниг
        if ('project' in el) {
            var i, groupName, group, project = el.project.current;
            for (i in groups) {
                group = groups[i];
                groupName = group.system_name;

                if (!project.calculator) {
                    continue;
                }

                if (!project.calculator.hasOwnProperty(groupName)) {
                    continue;
                }

                if (parseInt(group.is_countable) === 1) {
                    el.data[groupName] = project.calculator[groupName];
                    continue;
                }

                if (!el.properties.hasOwnProperty(groupName)) {
                    continue;
                }

                if (!el.properties[groupName].hasOwnProperty(project.calculator[groupName])) {
                    continue;
                }

                el.data[groupName] = project.calculator[groupName];
            }
        }

        var type = el.currentType;
        if (parseInt(type.binding_id) === el.REVERSAL_BINDING_ID) {
            el.data.reversals = el.countReversals;
        }

        if (parseInt(type.binding_id) === el.PAGE_BINDING_ID) {
            el.data.pages = el.countPages;
        }

        // если обложка не фотообложка показываем декоры
        if (
            el.coverGroup === el.NOTPHOTOCOVER
            && !el.data.hasOwnProperty('photo_insert')
            && !el.data.hasOwnProperty('nameplate')
            && !el.data.hasOwnProperty('lettering')
        ) {
            el.coverDecor.show(false);
        }

        // если обложка не фотообложка, то устанавливаем материал обложки в конструкторе
        el.setCoverMaterial(cb);
    };

    el.setCoverMaterial = function (cb) {
        // если обложка не фотообложка, то устанавливаем материал обложки в конструкторе
        if (parseInt(el.coverGroup) === el.NOTPHOTOCOVER
            && parseInt(el.properties.cover_material[el.data.cover_material].constructor_image) === 1
            && el.workData.hardcover
            && Object.keys(el.workData.hardcover[1].backgrounds).length === 0
        ) {
            el.hardcover.initDimensions();

            el.coverMaterial.set(window.companyId, el.data.cover_material, el.data.cover, function () {
                el.preview.updateAll();

                if (typeof cb === 'function') {
                    cb();
                }
            });
        } else {
            if (typeof cb === 'function') {
                cb();
            }
        }
    };

    el.updateCountData = function () {
        var type = el.currentType;
        if (parseInt(type.binding_id) === el.REVERSAL_BINDING_ID) {
            el.data.reversals = el.countReversals;
        }

        if (parseInt(type.binding_id) === el.PAGE_BINDING_ID) {
            el.data.pages = el.countPages;
        }
    };

    el.get = function () {
        return el.data;
    };

    el.getCurrentPrice = function () {
        var book = el.data;

        if (
            price.hasOwnProperty(book.book_types)
            && price[book.book_types].hasOwnProperty(book.formats)
        ) {
            return price[book.book_types][book.formats];
        }

        return {};
    };

    el.getPropertyCost = function (prices, groupName, count) {
        let currentCount = 1;
        
        if (groupName === 'paper') {
            currentCount = count;
        }

        let result = 0;
        let price;
        for (let count in prices) {
            price = prices[count];

            if(currentCount >= count) {
                result = price;
            }
        }

        return parseFloat(result);
    };

    el.getPropertyGroups = function () {
        return groups;
    };

    el.update = function (data) {
        var showMessage = false;
        //        if (Object.keys(el.data.decors).length !== Object.keys(data.decors).length) {
        //            showMessage = true;
        //        }

        el.data = data;
        el.coverGroup = el.properties.cover[el.data.cover].group_id;
        el.calcCost();
        el.render();
        el.coverDecor.initHardcover();
        if (
            parseInt(el.coverGroup) === el.NOTPHOTOCOVER
            && el.properties.cover_material.hasOwnProperty(el.data.cover_material)
            && parseInt(el.properties.cover_material[el.data.cover_material].constructor_image) === 1
        ) {
            el.coverMaterial.set(window.companyId, el.data.cover_material, el.data.cover, function () {
                el._parent.hardcover.isGenerated = false;
                el.hardcover.generate();
            });
        }

        if (showMessage) {
            el.dialog.show('message', {
                message: Yii.t('The number of applied decors on the cover has changed.')
            });

            el._parent.mode = 'hardcover';
            el._parent.currentReversal = 1;
            el.pagestep.selectConstructor();
        }

        if (el._parent.hasOwnProperty('flyleaf') && el.flyleaf.isAvailable()) {
            el.flyleaf.initData();
        }
    };

    el.calcCost = function () {
        var book = el.data;
        var cost = 0;

        var currentPrice = el.getCurrentPrice();
        var type = el.currentType;

        var i, group, groupName, propertyId, propertyPrice;
        for (i in groups) {
            group = groups[i];
            groupName = group.system_name;
            propertyId = book[groupName];

            if (!parseInt(group.has_price)) {
                continue;
            }

            if (currentPrice.hasOwnProperty(groupName) && currentPrice[groupName].hasOwnProperty(propertyId)) {
                propertyPrice = currentPrice[groupName][propertyId];
                if (!parseInt(group.price_depends_on_pages)) {
                    cost += el.getPropertyCost(propertyPrice, groupName, 1);
                    continue;
                }

                if (parseInt(type.binding_id) === 1) {
                    cost += book.reversals * el.getPropertyCost(propertyPrice, groupName, book.reversals);
                }

                if (parseInt(type.binding_id) === 2) {
                    cost += book.pages * el.getPropertyCost(propertyPrice, groupName, book.pages);
                }
            }
        }

        cost *= book.count;
        el.setCost(cost);
    };

    el.setCost = function (cost) {
        $('.cost').text(cost.toFixed(2));
    };

    el.render = function () {
        var templateData = {
            groups: [],
            currency: currency
        };

        var book = el.data;
        var properties = el.properties;


        var value, templateGroup, property, currentPrice, cost, type;
        var i, group, propertyPrice;
        for (i in groups) {
            if (!groups.hasOwnProperty(i)) {
                continue;
            }

            group = groups[i];
            cost = 0;
            currentPrice = el.getCurrentPrice();
            type = el.currentType;

            if (!book.hasOwnProperty(group.system_name)) {
                continue;
            }

            // Без use_individual общие развороты/страницы дублируют общее кол-во — не показываем
            if ((group.system_name === 'common_reversals' || group.system_name === 'common_pages') && !(type && parseInt(type.use_individual))) {
                continue;
            }

            value = book[group.system_name];

            templateGroup = {
                name: group.name
            };

            if (!parseInt(group.is_countable)) {
                if (!properties.hasOwnProperty(group.system_name)) {
                    continue;
                }

                if (!properties[group.system_name].hasOwnProperty(value)) {
                    continue;
                }

                property = properties[group.system_name][value];
                templateGroup.value = property.name;

                if (parseInt(group.has_price)) {
                    if (currentPrice.hasOwnProperty(group.system_name) && currentPrice[group.system_name].hasOwnProperty(value)) {
                        propertyPrice = currentPrice[group.system_name][value];
                        if (!parseInt(group.price_depends_on_pages)) {
                            cost += el.getPropertyCost(propertyPrice, group.system_name, 1);
                        }

                        if (type && parseInt(group.price_depends_on_pages) && parseInt(type.binding_id) === 1) {
                            cost += book.reversals * el.getPropertyCost(propertyPrice, group.system_name, book.reversals);
                        }

                        if (type && parseInt(group.price_depends_on_pages) && parseInt(type.binding_id) === 2) {
                            cost += book.pages * el.getPropertyCost(propertyPrice, group.system_name, book.pages);
                        }

                        templateGroup.cost = cost.toFixed(2);
                    }
                }
            }

            if (parseInt(group.is_countable)) {
                templateGroup.value = value;
            }

            templateData.groups.push(templateGroup);
        }

        $('#parameters').html(window.Mustache.render(template, templateData));
    };

    el.onloadHardcoverImage = function (image) {
        $('#parameters-image-layer-1, #parameters-image-layer-3').css('background-size', 'cover');

        var imageSize = {
            width: parseInt(image.width / 2),
            height: image.height
        };
        var size = {
            width: parseInt(image.width / 2),
            height: image.height
        };

        var wrapperSize = {
            width: $('#parameters-image').width(),
            height: $('#parameters-image').height()
        };

        if (imageSize.width > wrapperSize.width) {
            size.width = wrapperSize.width;
            size.height = parseInt((wrapperSize.width / imageSize.width) * imageSize.height);
        }

        if (size.height > wrapperSize.height) {
            size.height = wrapperSize.height;
            size.width = parseInt((wrapperSize.height / imageSize.height) * imageSize.width);
        }

        $('#parameters-image-layer-1, #parameters-image-layer-3').css('background-image', 'url(' + image.src + ')');
        $('#parameters-image-layer-2, #parameters-image-layer-3').css('height', size.height + 'px');
        $('#parameters-image-layer-1').css('height', (size.height - 20) + 'px');
        $('.parameters-image-layer').css('width', size.width + 'px');
    };

    el.getHardcoverURL = function () {
        return "/upload/book_projects/" + window.bookSid + "/reversals/hardcover_01.jpg?v=" + new Date().getTime();
    };

    el.getEmptyRequiredGroups = function () {
        const requiredProperties = [
            'group_type', // Группа фотокниг
            'book_types', // Тип фотокниги
            'formats', // Формат
            'cover', // Обложка
            'cover_material', // Материал обложки
            'paper', // Бумага
            'flyleaf', // Форзац
            'flyleaf_material', // Материал форзаца
            'decor', // Декорирование обложки
            'decor_locations', // Варианты размещения декора
            'decor_forms', // Варианты нанесения декора
            'cases', // Футляр
            'kalka', // Калька
        ];

        const groupsArr = Object.values(groups);
        const book = el.data;

        const emptyProperties = [];

        requiredProperties.forEach((property) => {
            const group = groupsArr.find((item) => property === item.system_name);

            if (!group) {
                return;
            }

            const options = getGroupProperties(group);
            const value = book[group.system_name];

            /** значение должно быть из списка допустимых значений */
            const isAvailableValue = options.some((item) => {
                return String(item.id) === String(value);
            });

            if (options.length && (!value || !isAvailableValue)) {
                emptyProperties.push(group);
            }
        });

        return emptyProperties;
    };

    function getGroupProperties(group) {
        const properties = [];

        if (parseInt(group.is_countable)) {
            return [];
        }

        const parentGroup = getGroupById(group.parent_id);
        const currentPrice = el.getCurrentPrice();

        const groupProperties = el.properties[group.system_name];
        let i, property;

        for (i in groupProperties) {
            if (!groupProperties.hasOwnProperty(i)) {
                continue;
            }

            property = groupProperties[i];

            if (parseInt(group.has_price) && parseInt(property.id) !== 0 && (!currentPrice.hasOwnProperty(group.system_name) || !currentPrice[group.system_name].hasOwnProperty(property.id))) {
                continue;
            }

            if (group.parent_id !== null && parseInt(property.id) !== 0) {
                const parentPropertyId = el.data[parentGroup.system_name];

                if (el.propLinks.hasOwnProperty(parentGroup.id) && parseInt(parentPropertyId) === 0) {
                    return [];
                }

                if (el.propLinks.hasOwnProperty(parentGroup.id) && !isExistChild(parentGroup.id, parentPropertyId, property.id)) {
                    continue;
                }

                // для типа фотокниг
                if (property.hasOwnProperty('group_type_id') && parentPropertyId && !(parseInt(property.group_type_id) === parseInt(parentPropertyId))) {
                    continue;
                }

                // для форматов
                if (
                    group.system_name === 'formats'
                    && (
                        !price.hasOwnProperty(el.data.book_types)
                        || !price[el.data.book_types].hasOwnProperty(property.id)
                    )
                ) {
                    continue;
                }
            }

            properties.push(property);
        }

        return properties;
    }

    function isExistChild(parentGroupId, parentPropertyId, childPropertyId) {
        let existProperty = false;

        if (el.propLinks.hasOwnProperty(parentGroupId) && el.propLinks[parentGroupId].hasOwnProperty(parentPropertyId)) {
            const childs = el.propLinks[parentGroupId][parentPropertyId];
            let j, child;
            for (j in childs) {
                if (!childs.hasOwnProperty(j)) {
                    continue;
                }

                child = childs[j];

                if (parseInt(child) === parseInt(childPropertyId)) {
                    existProperty = true;
                }
            }
        }

        return existProperty;
    }

    function getGroupById(id) {
        return Object.values(groups).find((item) => +item.id === +id);
    }

    $('.js-calculator-show').on('click', function () {
        el.show();
    });
};
